import * as React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { SmartLinkExplainer } from '@/routes/_layout/smart-link/-components/smart-link-explainer';
export const Route = createFileRoute('/_layout/smart-link/')({
    component: SmartLinkExplainedPage,
    head: () => ({
        meta: [
            { title: 'Adora Smart Link — Intent Tracking' },
            {
                name: 'description',
                content: 'Adora Smart Link tracks when people scan or click, where they are, and what they click next—so you understand intent.',
            },
        ],
    }),
});
function SmartLinkExplainedPage() {
    return <SmartLinkExplainer />;
}
